module.exports = __webpack_public_path__ + "img/red-x.76179c7f.svg";